module.exports = __webpack_public_path__ + "img/caixas-diversidade.991a26e8.svg";